module.exports = __webpack_public_path__ + "static/img/qiangchai2.7153be7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/qiangchai2.png
// module id = wHg9
// module chunks = 24